import { jsx as l, jsxs as d, Fragment as f } from "react/jsx-runtime";
import N from "react";
import x from "../List/index.js";
import b from "../Icon/index.js";
const v = ({ pages: c, current: i, homeIcon: a = "other_houses", divider: s = "/", linkComponent: e, isGatsby: r = !1, className: t, children: u, ...h }) => {
  const m = e || "a";
  return /* @__PURE__ */ l(
    "div",
    {
      className: `sash-Breadcrumbs ${t || ""}`,
      ...h,
      children: /* @__PURE__ */ d(
        x,
        {
          bullets: "none",
          layout: "inline",
          className: "flex-nowrap items-center overflow-x-auto overflow-y-hidden leading-none",
          children: [
            a && /* @__PURE__ */ l("li", { children: /* @__PURE__ */ d(
              m,
              {
                to: r && e ? "/" : null,
                href: !r || r && !e ? "/" : null,
                className: "block no-underline",
                children: [
                  /* @__PURE__ */ l(
                    b,
                    {
                      name: a,
                      className: "block !leading-none"
                    }
                  ),
                  /* @__PURE__ */ l("span", { className: "sr-only", children: "Home" })
                ]
              }
            ) }),
            (c == null ? void 0 : c[0]) && c.map((n, o) => /* @__PURE__ */ d(N.Fragment, { children: [
              (a || !a && o !== 0) && /* @__PURE__ */ l("li", { className: "mx-1.5", children: s }),
              /* @__PURE__ */ l("li", { children: n.url ? /* @__PURE__ */ l(
                m,
                {
                  "data-testid": "breadcrumbs-link",
                  to: r && e ? n.url : null,
                  href: !r || r && !e ? n.url : null,
                  className: "underline hover:no-underline",
                  children: n.title
                }
              ) : n.title })
            ] }, o)),
            u,
            i && /* @__PURE__ */ d(f, { children: [
              /* @__PURE__ */ l("li", { className: "mx-1.5", children: s }),
              /* @__PURE__ */ l("li", { children: i })
            ] })
          ]
        }
      )
    }
  );
}, F = v;
export {
  F as default
};
